import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl } from "../../Baseurl";

const DirectSellRequest = () => {
  const seller_id = localStorage.getItem("seller_id");
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [searchTitle, setSearchTitle] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await axios.get(`${baseurl}/getDirectSalesBySellerId/${seller_id}`);
        setSales(response.data.sales || []);
        setFilteredSales(response.data.sales || []);
      } catch (error) {
        console.error("Error fetching direct sales:", error);
      } finally {
        setLoading(false);
      }
    };

    if (seller_id) fetchSales();
  }, [seller_id]);

  useEffect(() => {
    let filtered = sales;

    if (searchTitle)
      filtered = filtered.filter((item) =>
        item.title?.toLowerCase().includes(searchTitle.toLowerCase())
      );

    if (customerId)
      filtered = filtered.filter((item) => item.cust_id?.toString().includes(customerId));

    if (contactNumber)
      filtered = filtered.filter((item) => item.contact_number?.includes(contactNumber));

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      filtered = filtered.filter((item) => {
        const created = new Date(item.created_at);
        return created >= start && created <= end;
      });
    }

    setFilteredSales(filtered);
  }, [searchTitle, customerId, contactNumber, startDate, endDate, sales]);

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1 mb-3">Direct Sell Requests</h4>

                  {/* Filters */}
                  <div className="card p-3 mb-3">
                    <div className="row g-2">
                      <div className="col-md-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Title"
                          value={searchTitle}
                          onChange={(e) => setSearchTitle(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Customer ID"
                          value={customerId}
                          onChange={(e) => setCustomerId(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Contact Number"
                          value={contactNumber}
                          onChange={(e) => setContactNumber(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="card p-3">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="custom-table ">
                          <thead className="table-dark">
                            <tr>
                              <th>Title</th>
                              <th>Customer ID</th>
                              <th>Contact No.</th>
                              <th>WhatsApp No.</th>
                              <th>Shipping Address</th>
                              <th>Purchase Note</th>
                              <th>Created At</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredSales.length > 0 ? (
                              filteredSales.map((row) => (
                                <tr key={row.id}>
                                  <td>{row.title}</td>
                                  <td>{row.cust_id}</td>
                                  <td>{row.contact_number}</td>
                                  <td>{row.whatsapp_number}</td>
                                  <td>{row.shipping_address}</td>
                                  <td>{row.purchase_note}</td>
                                  <td>{new Date(row.created_at).toLocaleString()}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No matching records found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectSellRequest;
